module.exports = __webpack_public_path__ + "img/banner2.2c423826.png";